import { render, staticRenderFns } from "./JaliscoDoughutCharComponent.vue?vue&type=template&id=2a74af1d&scoped=true"
import script from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
export * from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=2a74af1d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74af1d",
  null
  
)

export default component.exports